/**
 * Límites visuales de conducción diaria para resaltar en la pantalla de jornadas.
 * TODO(decision): límite legal a confirmar. Son valores provisorios y solo afectan
 * el color: no generan alertas ni se envían a ningún lado.
 */
export const LIMITE_CONDUCCION_H = 9;
/** A partir de este exceso sobre el límite se marca en rojo en vez de ámbar. */
export const EXCESO_CRITICO_H = 2;
